import { request } from '@umijs/max';
/** 专家库登录 POST /api/expert/login/account */
export async function expertLogin(body, options) {
    return request('/api/expert/login/account', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        skipErrorHandler: true,
        ...(options || {}),
    });
}
/** 获取当前专家用户 GET /api/expert/currentUser */
export async function expertCurrentUser(options) {
    return request('/api/expert/currentUser', {
        method: 'GET',
        skipErrorHandler: true,
        ...(options || {}),
    });
}
/** 专家库退出 POST /api/expert/login/outLogin */
export async function expertOutLogin(options) {
    return request('/api/expert/login/outLogin', {
        method: 'POST',
        ...(options || {}),
    });
}
/** 专家库注册 POST /api/expert/register */
export async function expertRegister(data, options) {
    return request('/api/expert/register', {
        data,
        method: 'POST',
        ...(options || {}),
    });
}
